import type { CID } from 'multiformats/cid';

import type { CidDownloadLogger } from '@/services/abstract/poc/CidDownloadLogger';
import type { AddFileResult, HeliaNode, ProgressCallback } from '@/types/poc/helia';

export interface GetFileOptions {
  onProgress?: ProgressCallback;
  downloadLogger?: CidDownloadLogger;
  expectedSize?: number;
  signal?: AbortSignal;
}

export abstract class FileStoreService {
  abstract addFile(
    node: HeliaNode,
    file: File,
    onProgress?: ProgressCallback
  ): Promise<AddFileResult>;

  abstract getFile(
    node: HeliaNode,
    cid: string | CID,
    options?: GetFileOptions
  ): Promise<Uint8Array>;

  abstract fileExists(node: HeliaNode, cid: string | CID): Promise<boolean>;

  abstract pinFile(node: HeliaNode, cid: string | CID): Promise<void>;
  abstract unpinFile(node: HeliaNode, cid: string | CID): Promise<void>;
  abstract isPinned(node: HeliaNode, cid: string | CID): Promise<boolean>;

  abstract verifyDagIntegrity(
    node: HeliaNode,
    cid: CID,
    expectedSize?: number,
    expectedHash?: string
  ): Promise<DagIntegrityResult>;
}

export type DagIntegrityResult =
  | { valid: true; byteCount: number }
  | { valid: false; error: string };
